import api from "./axios";

export async function getCurrentAIAllowance() {
  const response = await api.get("/ai-allowance/current");
  return response.data;
}
